/* eslint-disable */
import base64url from 'base64url';
import {
  deleteEkgRecordingFromStack,
  postConfirmEkgRecording,
  putReassignEkgRecording,
  getDataSource,
  getMe,
} from '../../store/appReducer';
import {
  ROUTES,
  DATASOURCES,
  TRIAGE,
  ECG_STACK_CONTROLS_ACTION_TYPE,
  CLEAR_STATE,
} from '../../constants';
import history from '../../containers/History';
import {
  handleOnNavClick as handleOnEkgReviewNavClick,
  getEkgStack,
  updateSelectedInboxId as EkgReviewUpdateSelectedInboxId,
  updateSelectedPatientId as EkgReviewUpdateSelectedPatientId,
  updateSelectedPhysicianId as EkgReviewUpdateSelectedPhysicianId,
  updateSelectedPhysicians as EkgReviewUpdateSelectedPhysicians,
  updateSelectedBpmValues as EkgReviewUpdateSelectedBpmValues,
  updateSelectedDates as EkgReviewUpdateSelectedDates,
  updateSelectedEkgResult as EkgReviewUpdateSelectedEkgResult,
  dataSuccess as EkgStackDataSuccess,
  dataFailure as EkgStackDataFailure,
  getRecordingIdsFromDataSource,
} from '../../pages/EkgReview/module';

import {
  checkMedantaAPIFeatureEnabled,
  checkServiceProviderFeatureEnabled,
} from 'configs';
import {
  getEkgStack as getQtEkgStack,
  handleOnNavClick as handleOnQtEkgReviewNavClick,
} from '../../pages/QtEkgReview/module';

// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'EkgReviewEkgRecording.';
export const UPDATE_SELECTED_RECORDING_ID = `${PREFIX}UPDATE_SELECTED_RECORDING_ID`;
export const UPDATE_SELECTED_REASSIGN_INBOX_ID = `${PREFIX}UPDATE_SELECTED_REASSIGN_INBOX_ID`;
export const UPDATE_SELECTED_INBOX_ID = `${PREFIX}UPDATE_SELECTED_INBOX_ID`;
export const UPDATE_RECORDING_IDS = `${PREFIX}UPDATE_RECORDING_IDS`;

// ------------------------------------
// Actions
// ------------------------------------
export const updateSelectedRecordingId = recordingId => ({
  type: UPDATE_SELECTED_RECORDING_ID,
  payload: recordingId,
});
export const updateSelectedReassignInboxId = reassignInboxId => ({
  type: UPDATE_SELECTED_REASSIGN_INBOX_ID,
  payload: reassignInboxId,
});
export const updateSelectedInboxId = inboxId => ({
  type: UPDATE_SELECTED_INBOX_ID,
  payload: inboxId,
});
export const updateRecordingIds = recordingIds => ({
  type: UPDATE_RECORDING_IDS,
  payload: recordingIds,
});

export const clearSelectedRecordingId = () => dispatch => {
  dispatch(updateSelectedRecordingId(''));
};

export const clearSelectedReassignInboxId = () => dispatch => {
  dispatch(updateSelectedReassignInboxId(''));
};

export const setInitialEkgReviewEkgRecordingData = (
  match,
  inboxId,
  filters = {},
) => (dispatch, getState) => {
  const { recordingId } = match.params;
  // selectedInboxId doesn't get set when browser reloads
  const { selectedInboxId: ekgReviewSelectedInboxId } = getState().ekgReview; // ekgReviewEkgRecording

  // use case: when user refreshes the browser and we have retrieve stack again
  if (ekgReviewSelectedInboxId === undefined) {
    dispatch(EkgReviewUpdateSelectedInboxId(inboxId));
    const {
      selectedPatientId,
      selectedPhysicianId,
      selectedPhysicians,
      selectedEkgResult,
      selectedStartDate,
      selectedEndDate,
      selectedBpmStartValue,
      selectedBpmEndValue,
    } = filters;
    // handle EkgReview filters
    if (selectedPatientId) {
      dispatch(EkgReviewUpdateSelectedPatientId(selectedPatientId));
    }
    if (selectedPhysicianId) {
      dispatch(EkgReviewUpdateSelectedPhysicianId(selectedPhysicianId));
    }
    if (selectedPhysicians) {
      const physicians = selectedPhysicians.split(',').map(id => ({
        id,
      }));
      dispatch(EkgReviewUpdateSelectedPhysicians(physicians));
    }
    if (selectedEkgResult) {
      const ekgResult = selectedEkgResult.split(',').map(id => ({
        id,
      }));
      dispatch(EkgReviewUpdateSelectedEkgResult(ekgResult));
    }
    if (selectedStartDate && selectedEndDate) {
      dispatch(
        EkgReviewUpdateSelectedDates({
          startDate: new Date(parseInt(selectedStartDate, 10)),
          endDate: new Date(parseInt(selectedEndDate, 10)),
        }),
      );
    }
    if (selectedBpmStartValue && selectedBpmEndValue) {
      dispatch(
        EkgReviewUpdateSelectedBpmValues({
          startValue: parseInt(selectedBpmStartValue, 10),
          endValue: parseInt(selectedBpmEndValue, 10),
        }),
      );
    }
    let promises;
    const meDataSource = getDataSource(getState(), DATASOURCES.ME);
    if (meDataSource.data) {
      promises = Promise.resolve();
    } else {
      promises = dispatch(getMe());
    }
    return promises.then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const serviceProviderFeature =
        me.data.teams[0].features &&
        me.data.teams[0].features.find(
          feat => feat.feature === 'qt-service-provider',
        );
      const serviceProviderEnabled = serviceProviderFeature
        ? serviceProviderFeature.enabled
        : false;
      const getStack = serviceProviderEnabled ? getQtEkgStack() : getEkgStack();
      dispatch(getStack)
        .then(() => {
          dispatch(EkgStackDataSuccess());
          const recordingIds = getRecordingIdsFromDataSource(getState());
          if (serviceProviderEnabled) {
            // for service providers, initial view is oldest first
            const recordingIdsReverse = recordingIds.reverse();
            dispatch(updateRecordingIds(recordingIdsReverse));
          } else {
            dispatch(updateRecordingIds(recordingIds));
          }
        })
        .catch(err => dispatch(EkgStackDataFailure()));
    });
  }

  dispatch(updateSelectedRecordingId(recordingId));
};

export const removeFromStackCallback = (
  actionType,
  currentInboxId = undefined,
  currentRecordingId = '',
  recordingIds = undefined,
) => (dispatch, getState) => {
  const { selectedRecordingId } = getState().ekgReviewEkgRecording;

  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  const meDataSourceTeams = (meDataSource.data && meDataSource.data.teams) || [
    {
      id: null,
    },
  ];

  const teamId = meDataSourceTeams[0].id;

  switch (actionType) {
    case ECG_STACK_CONTROLS_ACTION_TYPE.CANCEL:
      break;
    case ECG_STACK_CONTROLS_ACTION_TYPE.OK:
      return new Promise((resolve, reject) => {
        dispatch(deleteEkgRecordingFromStack(teamId, selectedRecordingId))
          .then(() => {
            if (
              recordingIds &&
              recordingIds.indexOf(currentRecordingId) < recordingIds.length - 1
            ) {
              const currentRecordingIdIndex = recordingIds.indexOf(
                currentRecordingId,
              );
              recordingIds.splice(currentRecordingIdIndex, 1);

              dispatch(
                handleOnNavClick(true, {
                  recordingId: recordingIds[currentRecordingIdIndex],
                  currentInboxId,
                  recordingIds,
                }),
              );
            } else {
              dispatch(
                handleOnEkgReviewNavClick(false, true, {
                  inboxId: currentInboxId,
                }),
              );
            }
            resolve();
          })
          .catch(err => {
            console.log('removeFromStackCallback', err);
            reject(err);
          });
      });
    default:
      break;
  }
};
export const confirmAndArchiveCallback = (
  actionType,
  currentInboxId = undefined,
  currentRecordingId = '',
  recordingIds = undefined,
) => (dispatch, getState) => {
  const { selectedRecordingId } = getState().ekgReviewEkgRecording;

  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  const isServiceProviderEnabled = checkServiceProviderFeatureEnabled(
    meDataSource,
  );
  const ekgsDataSource = getDataSource(getState(), DATASOURCES.EKGS);
  const recording = ekgsDataSource.data.byId[selectedRecordingId];

  const mostRecentInterpretation = recording.memberInterpretations[0];

  switch (actionType) {
    case ECG_STACK_CONTROLS_ACTION_TYPE.CANCEL:
      break;
    case ECG_STACK_CONTROLS_ACTION_TYPE.OK:
      return new Promise((resolve, reject) => {
        dispatch(postConfirmEkgRecording(mostRecentInterpretation.id))
          .then(() => {
            if (
              recordingIds &&
              recordingIds.indexOf(currentRecordingId) < recordingIds.length - 1
            ) {
              const currentRecordingIdIndex = recordingIds.indexOf(
                currentRecordingId,
              );
              recordingIds.splice(currentRecordingIdIndex, 1);

              dispatch(
                handleOnNavClick(true, {
                  recordingId: recordingIds[currentRecordingIdIndex],
                  currentInboxId,
                  recordingIds,
                }),
              );
            } else {
              if (!isServiceProviderEnabled) {
                dispatch(
                  handleOnEkgReviewNavClick(false, true, {
                    inboxId: currentInboxId,
                  }),
                );
              } else {
                dispatch(
                  handleOnQtEkgReviewNavClick(false, true, {
                    inboxId: currentInboxId,
                  }),
                );
              }
            }
            resolve();
          })
          .catch(err => {
            console.log('confirmAndArchiveCallback', err);
            reject(err);
          });
      });
    default:
      break;
  }
};
export const reassignCallback = (
  actionType,
  currentInboxId = undefined,
  currentRecordingId = '',
  recordingIds = undefined,
) => (dispatch, getState) => {
  const {
    selectedRecordingId,
    selectedReassignInboxId,
  } = getState().ekgReviewEkgRecording;

  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  const isServiceProviderEnabled = checkServiceProviderFeatureEnabled(
    meDataSource,
  );
  const meDataTeams = meDataSource.data.teams;
  let memberID = selectedReassignInboxId;

  if (selectedReassignInboxId === TRIAGE) {
    memberID = null;
  }
  const assignmentData = {
    memberID,
    teamID: meDataTeams[0].id,
  };

  switch (actionType) {
    case ECG_STACK_CONTROLS_ACTION_TYPE.CANCEL:
      return dispatch(updateSelectedReassignInboxId(''));
    case ECG_STACK_CONTROLS_ACTION_TYPE.OK:
      return new Promise((resolve, reject) => {
        dispatch(putReassignEkgRecording(selectedRecordingId, assignmentData))
          .then(() => {
            if (
              recordingIds &&
              recordingIds.indexOf(currentRecordingId) < recordingIds.length - 1
            ) {
              console.log('==== If part');
              const currentRecordingIdIndex = recordingIds.indexOf(
                currentRecordingId,
              );
              recordingIds.splice(currentRecordingIdIndex, 1);

              dispatch(
                handleOnNavClick(true, {
                  recordingId: recordingIds[currentRecordingIdIndex],
                  currentInboxId,
                  recordingIds,
                }),
              );
            } else {
              if (!isServiceProviderEnabled) {
                dispatch(
                  handleOnEkgReviewNavClick(false, true, {
                    inboxId: currentInboxId,
                  }),
                );
              } else {
                dispatch(
                  handleOnQtEkgReviewNavClick(false, true, {
                    inboxId: currentInboxId,
                  }),
                );
              }
            }
            resolve();
          })
          .catch(err => {
            console.log('confirmAndArchiveCallback', err);
            reject(err);
          });
      });
    default:
      break;
  }
};

export const handleOnNavClick = (
  replaceInsteadOfPush = false,
  { recordingId = '', inboxId = undefined, recordingIds = undefined },
) => (dispatch, getState) =>
  Promise.resolve()
    .then(() => {
      let qs = '';
      let base64Encoded = '';
      if (inboxId) {
        qs += `?inboxId=${inboxId}`;
        // check to see if there are other filters applied to recordingIds
        const {
          selectedStartDate,
          selectedEndDate,
          selectedPatientId,
          selectedPhysicianId,
          selectedPhysicians,
          selectedEkgResult,
          selectedBpmStartValue,
          selectedBpmEndValue,
        } = getState().ekgReview;

        const filters = {};
        if (selectedStartDate && selectedEndDate) {
          filters.selectedStartDate = selectedStartDate.getTime();
          filters.selectedEndDate = selectedEndDate.getTime();
        }
        if (selectedPatientId) {
          filters.selectedPatientId = selectedPatientId;
        }
        if (selectedPhysicianId) {
          filters.selectedPhysicianId = selectedPhysicianId;
        }
        if (selectedPhysicians && selectedPhysicians.length > 0) {
          filters.selectedPhysicians = selectedPhysicians
            .map(e => e.id)
            .join(',');
        }
        if (selectedEkgResult) {
          filters.selectedEkgResult = selectedEkgResult
            .map(e => e.id)
            .join(',');
        }
        if (selectedBpmStartValue && selectedBpmEndValue) {
          filters.selectedBpmStartValue = selectedBpmStartValue;
          filters.selectedBpmEndValue = selectedBpmEndValue;
        }

        // base64 encrypt to make url not too long
        // and to prevent manipulation by not making it easily known the actual filter param/value used by the ui.
        base64Encoded = `&filters=${base64url(JSON.stringify(filters))}`;
      }
      if (replaceInsteadOfPush) {
        history.replace(
          `${ROUTES.EKG_REVIEW_EKG_RECORDING}/${recordingId}${qs}${base64Encoded}`,
        );
      } else {
        history.push(
          `${ROUTES.EKG_REVIEW_EKG_RECORDING}/${recordingId}${qs}${base64Encoded}`,
        );
      }
    })
    .then(() => {
      dispatch(updateSelectedRecordingId(recordingId));
      dispatch(updateRecordingIds(recordingIds));
      dispatch(updateSelectedInboxId(inboxId));
    });

const initialState = {
  selectedRecordingId: '',
  selectedReassignInboxId: '',
  selectedInboxId: '',
  recordingIds: undefined,
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_SELECTED_RECORDING_ID]: (state, action) => ({
    ...state,
    selectedRecordingId: action.payload,
  }),
  [UPDATE_SELECTED_REASSIGN_INBOX_ID]: (state, action) => ({
    ...state,
    selectedReassignInboxId: action.payload,
  }),
  [UPDATE_SELECTED_INBOX_ID]: (state, action) => ({
    ...state,
    selectedInboxId: action.payload,
  }),
  [UPDATE_RECORDING_IDS]: (state, action) => ({
    ...state,
    recordingIds: action.payload,
  }),
  [CLEAR_STATE]: () => ({ ...initialState }),
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function ekgReviewEkgRecordingReducer(
  state = initialState,
  action,
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/legacy/pages/EkgReviewEkgRecording/module.js